import type { Media, Theme } from '../../types/props'

export interface FeatureShowcaseItem {
  /** 标题 */
  title: string
  /** 描述文本 */
  desc: string
  /** 桌面端图片 URL */
  image: Media
  /** 移动端图片 URL */
  imageMob: Media
}

export interface FeatureShowcaseProps {
  data: {
    /** 第一组数据列表 */
    datalist: FeatureShowcaseItem[]
    /** 第二组数据列表 */
    datalists: FeatureShowcaseItem[]
    /** 主题，默认 light */
    theme?: Theme
  }
  /** 自定义类名 */
  className?: string
}
